var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatuscheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#189510"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8883 19.1932C45.6785 18.9818 45.429 18.8139 45.1541 18.6994C44.8792 18.5848 44.5843 18.5259 44.2864 18.5259C43.9886 18.5259 43.6937 18.5848 43.4188 18.6994C43.1439 18.8139 42.8943 18.9818 42.6846 19.1932L25.8767 36.0237L18.8151 28.9396C18.5973 28.7292 18.3403 28.5638 18.0586 28.4528C17.7769 28.3418 17.4761 28.2874 17.1734 28.2926C16.8707 28.2978 16.5719 28.3626 16.2943 28.4833C16.0166 28.604 15.7654 28.7782 15.555 28.996C15.3447 29.2137 15.1793 29.4708 15.0683 29.7525C14.9573 30.0342 14.9028 30.335 14.9081 30.6377C14.9133 30.9404 14.9781 31.2391 15.0988 31.5168C15.2195 31.7945 15.3937 32.0457 15.6114 32.256L24.2749 40.9194C24.4846 41.1309 24.7341 41.2987 25.009 41.4133C25.284 41.5278 25.5789 41.5868 25.8767 41.5868C26.1745 41.5868 26.4694 41.5278 26.7443 41.4133C27.0193 41.2987 27.2688 41.1309 27.4785 40.9194L45.8883 22.5097C46.1173 22.2984 46.3 22.042 46.425 21.7566C46.55 21.4712 46.6146 21.163 46.6146 20.8515C46.6146 20.5399 46.55 20.2317 46.425 19.9463C46.3 19.6609 46.1173 19.4045 45.8883 19.1932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatuscheck);
export default __webpack_public_path__ + "static/media/statuscheck.b3e4f4559e804b662ace10dc6707dc9b.svg";
export { ForwardRef as ReactComponent };